import Swal from 'sweetalert2';

const CustomSwal = Swal.mixin({
    didOpen: (popup) => {
        popup.style.zIndex = '999999'; // Set your desired z-index
    },
});

export default CustomSwal;
